<template>
  <div>
    <section v-if="showThankYou">
      <div class="container">
        <div class="card info-message">
          <b>Thank you for your subscription.</b>
          Please watch the video below that expains all services you have access to.  
          You can also click on "Learn More" link below  to see what each service offers
        </div>
      </div>
    </section>
    <section id="platform">
      <div class="container">
      <div class="row align-items-center">
          <div class="col-md-6">
            <h1>Welcome To Your <br>
              Membership Dashboard</h1>
            <p>Congratulations! You've taken the first step toward finding better trades! From our Dashboard, you'll have access to everything we offer in your membership. If you ever get "lost", simply click Dashboard at the top of the screen to return to this page. </p>
            <p><strong>A Few Things To Note</strong><br>
              We've found the quickest way to familiarize yourself with everything we offer is by reading our <strong>GETTING STARTED</strong> guide. Traders who take a few minutes to review it almost always hit the ground running compared to traders who just "wing it". Get a jumpstart on your trading education — read the Getting Started guide now.</p>
          </div>
          <div class="col-md-6">
            <div class="container">
              <div class="list-group custom-list-group"> <a href="https://yellowtunnel.com/bk/guide.pdf" target="_blank" class="list-group-item list-group-item-action"> <img src="images/icons/icon-document.png" width="34" height="42" alt=""/>
                <p><strong> Getting Started Guide</strong><br>
                  Make the most of the YellowTunnel Platform by reading our Getting Started guide.</p>
                </a> <a :href="upcomingWebinarsLink" class="list-group-item list-group-item-action"> <img src="images/icons/icon-monitor-person.png" width="34" height="42" alt=""/>
                <p><strong> Live Educational Webinars</strong><br>
                  YellowTunnel offers Live online training sessions and webinars every week to help you Trade Smarter.</p>
                </a> <a href="/contact" class="list-group-item list-group-item-action"> <img src="images/icons/icon-headset.png" width="34" height="42" alt=""/>
                <p><strong> Dedicated Support</strong><br>
                  We are always available to answer any questions you may have throughout your learning process.</p>
                </a> <a href="/blog/trading-concepts" class="list-group-item list-group-item-action"> <img src="images/icons/icon-document-pen.png" width="34" height="42" alt=""/>
                <p><strong> Blog</strong><br>
                  Learn to Trade Smarter with dozens of short and to-the-point educational videos for all levels of traders.</p>
                </a> <a :href="recordedWebinarsLink" class="list-group-item list-group-item-action"> <img src="images/icons/icon-monitor-play.png" width="34" height="42" alt=""/>
                <p><strong> HD Webinar Recordings</strong><br>
                  Watch all of our past webinars on desktop, mobile, or tablet at your leisure in high definition video.</p>
                </a> </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="services" class="py-5">
      <div class="dashboard-container container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div id="dashboardCarousel" class="services carousel slide">
              <div class="carousel-inner">
                <div class="services-intro dashboard-carousel-item">
                  <h2>Find A Service That Fits Your Trading Needs</h2>
                  <p>Try any of the YellowTunnel Memberships for a full 30 days on a trial basis.</p>
                  <p>Click 'Learn More' link below to learn more about each service we offer at YellowTunnel.</p>
                </div>
                <div class="carousel-item" v-for="portfolio in portfolioLinks" :key="portfolio.id">
                  <div class="slide-wrapper">
                    <div class="row no-gutters d-flex align-items-stretch">
                      <div class="dashboard-carousel-item  pb-xl-5"> 
                        <div style="padding:56.25% 0 0 0;position:relative;">
                          <iframe class="tutorialVideo" src="https://player.vimeo.com/video/663043297" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowfullscreen></iframe>
                        </div>
                      </div>
                      <div class="dashboard-carousel-item">
                        <div class="slide-copy">
                          <p class="font-weight-bold mb-0">{{portfolio.title}}</p>
                          <p :id="portfolio.id">{{getDescription(portfolio)}}</p>
                          <p><a href="#" @click="learnMore(portfolio)">Learn More</a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ol class="carousel-indicators" >
                <li data-target="#dashboardCarousel" v-for="count in portfolioLinks.length" :key="count" :data-slide-to="count - 1"></li>
              </ol>
              <div class="carousel-control-wrapper"> <a class="carousel-control-prev" href="#dashboardCarousel" role="button" data-slide="prev"> <span class="carousel-control-prev-icon" aria-hidden="true"></span> <span class="sr-only">Previous</span> </a> <a class="carousel-control-next" href="#dashboardCarousel" role="button" data-slide="next"> <span class="carousel-control-next-icon" aria-hidden="true"></span> <span class="sr-only">Next</span> </a> </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: "Dashboard",
  props: {
    portfolioLinks: Array,
    loadPortfolio: Function,
    upcomingWebinars: Array,
    recordedWebinars: Array,    
  },
  data: function () {
      return {
          upcomingWebinarsLink: this.upcomingWebinars.length > 0 ? "/upcoming/category/" + this.upcomingWebinars[0]["title"] : "#",
          recordedWebinarsLink: this.recordedWebinars.length > 0 ? "/recorded/category/" + this.recordedWebinars[0]["title"] : "#",
          showThankYou: window.location.search.includes('info')
      }
  },
  mounted() {
    $('.carousel-item').first().addClass("active");
    $('.carousel-indicators li').first().addClass("active");
    this.getDescriptionPoints();     
  },
  methods: {
    learnMore(id) {
      this.loadPortfolio(id);
    },
    playTutorial(){
      $('button.play').click();
    },
    getDescriptionPoints(){
      for (let portfolio of this.portfolioLinks){
        let itemId = "#"+portfolio.id;
        let descriptionPoints = "";
        switch(portfolio.title) {
          case "Aggressive Power Trader Weekly": 
          case "Weekly Power Trader":  
          descriptionPoints = "<br><b><i>Here's what is included in your service:</b></i><br>"+
          "✅ <b>Strategy</b> - Sell OTM Put Spread or Buy Stock using DCA<br>✅ <b>Holding Period</b> - Only 5-10 days<br>"+
          "✅ <b>Alerts Issued</b> - Once a week<br>✅ <b>Target Gain</b> - 2% using stock; 10-50% using Put Spread<br>" +
          "✅ <b>Trade Delivery</b> - Email and Online";
          break;
          case "Aggressive Power Trader": 
          descriptionPoints = "<br><b><i>Here's what is included in your service:</b></i><br>"+
          "✅ <b>Trade Delivery</b> - Email and Online<br>✅ <b>Strategy</b> - Sell OTM put or buy stock using DCA<br>"+
          "✅ <b>Holding Period</b> - Only 1-2 days<br>✅ <b>Alerts Issued</b> - Once a day<br>✅ <b>Target Gain</b> - 1% using stock, 10-30% using options";
          break;
          case "Earnings Power Trader": 
          descriptionPoints = "<br><b><i>Here's what is included in your service:</b></i><br>"+
          "✅ <b>Strategy</b> - Sell OTM put and/or call spreads<br>✅ <b>Holding Period</b> - Only 1-2 days<br>"+
          "✅ <b>Alerts Issued</b> - once a day<br>✅ <b>Target Gain</b> - 10%-30%<br>✅ <b>Trade Delivery</b> - Email, Text Message and Online";
          break;
          case "Dynamic Power Trader":  
          descriptionPoints = "<br><b><i>Here's what is included in your service:</b></i><br>" +
          "✅ <b>Strategy</b> - Sell OTM option put spreads or Buy Stock using DCA<br>✅ <b>Holding Period</b> - 5-10 days<br>" +
          "✅ <b>Alerts Issued</b> - Once a week<br>✅ <b>Target Gain</b> - 2% using stock ; 10-40% using Put Spread<br>"+
          "✅ <b>Trade Delivery</b> - Email, Text Message and Online";
          break;
          case "Profit Accelerator Trader":  
          descriptionPoints = "<br><b><i>Here's what is included in your service:</b></i><br>" +
          "✅ <b>Strategy</b> - Buy Stock using DCA<br>✅ <b>Holding Period</b> - Only 10-90 days<br>" +
          "✅ <b>Alerts Issued</b> - Daily using SMS and emails<br>✅ <b>Target Gain</b> - 10%<br>"+
          "✅ <b>Trade Delivery</b> - Email, Text Message and Online";
          break;
         }
      
      $(itemId).append(descriptionPoints);
      }
    },
    getDescription(portfolio) {
      switch(portfolio.title) {
        case "Aggressive Power Trader Weekly": 
        case "Weekly Power Trader": 
          return "Get access to my proven, powerful, algorithmic trading system. Every week, you receive up to 10 trade recommendations in a mix of both stocks and options.";
        
        case "Aggressive Power Trader": 
          return "Despite the market being all over the place in recent years, this system was able to maintain virtually the exact same winning percentage of more than 86.21%.";

        case "Earnings Power Trader": 
          return "A brand-new service that combines the power of all of these trading principles and strategies into a single, data-backed approach to trading.";

        case "Dynamic Power Trader": 
          return "An improved version of a system that has been garnering a 86.21% win rate on all trades with both stocks and options.";

        case "Aggressive Power Life Time": 
          return "The only trading system you’ll ever need. Subscribe now for one year at the discounted rate and never pay an annual subscription fee again.";

        case "Profit Accelerator Trader": 
          return "With a new  Membership to Profit Accelerator Trader, you get access to my proven, powerful, algorithmic trading system. Every week, you receive up to 4-8  stock trade ideas along with SMS and Web access to Vlad's orders.  Each step you need to take is laid out in detail, with the entry and exit strategies laid out before you.";

        default: 
          return "";
      }
    }
  }
}
</script>

<style scoped>
    .info-message{
        font-size: 22px;
        padding: 20px;
    }
</style>